"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSfilterSizeCustomOption = void 0;
exports.defaultSfilterSizeCustomOption = {
    selectedFromIndex: 0,
    selectedToIndex: 13,
    from: [
        { value: 0 },
        { value: 400 },
        { value: 600 },
        { value: 800 },
        { value: 1000 },
        { value: 1200 },
        { value: 1500 },
        { value: 1700 },
        { value: 2000 },
        { value: 2500 },
        { value: 3000 },
        { value: 3500 },
        { value: 4000 },
        { value: 4500 },
    ],
    to: [
        { value: 400 },
        { value: 600 },
        { value: 800 },
        { value: 1000 },
        { value: 1200 },
        { value: 1500 },
        { value: 1700 },
        { value: 2000 },
        { value: 2500 },
        { value: 3000 },
        { value: 3500 },
        { value: 4000 },
        { value: 4500 },
        { value: -1 },
    ],
};
